import i18n from '@yandex-int/i18n';
import * as keyset from 'i18n/DraftsStatuses';
import { DraftStatus, DraftStatusSmartHome } from '../../model/draft';
import { Channel } from '../../model/skill';

const t = i18n(keyset);
type StatusLabelsSet<TStatus extends string> = Record<TStatus, string>;

const commonStrings: StatusLabelsSet<DraftStatus> = {
    [DraftStatus.InDevelopment]: t('draft-in-development'),
    [DraftStatus.ReviewRequested]: t('review-requested'),
    [DraftStatus.ReviewApproved]: t('review-approved'),
    [DraftStatus.DeployRequested]: t('deploy-requested'),
};

const smartHomeStrings: StatusLabelsSet<DraftStatusSmartHome> = {
    [DraftStatusSmartHome.InDevelopment]: t('sh-in-dev'),
    [DraftStatusSmartHome.ReviewRequested]: t('sh-review-requested'),
    [DraftStatusSmartHome.MeetingApproval]: t('sh-meeting'),
    [DraftStatusSmartHome.WaitingForTesting]: t('sh-waiting'),
    [DraftStatusSmartHome.DevicesTesting]: t('sh-testing'),
    [DraftStatusSmartHome.DevicesTestingCompleted]: t('sh-analysis'),
    [DraftStatusSmartHome.ReviewApproved]: t('sh-approved'),
    [DraftStatusSmartHome.DeployRequested]: t('deploy-requested'),
};

export const draftStatusLabels = {
    [Channel.AliceSkill]: commonStrings,
    [Channel.AutoApp]: { ...commonStrings, [DraftStatus.InDevelopment]: t('in-development') },
    [Channel.Thereminvox]: commonStrings,
    [Channel.SmartHome]: smartHomeStrings,
    [Channel.TvApp]: { ...commonStrings, [DraftStatus.InDevelopment]: t('in-development') },
    [Channel.SmartScreenApp]: { ...commonStrings, [DraftStatus.InDevelopment]: t('in-development') },
};

export const draftStatusHint: Record<DraftStatus | DraftStatusSmartHome, string> = {
    inDevelopment: t('hint-in-dev'),
    reviewRequested: '',
    meetingApproval: '',
    waitingForTesting: '',
    devicesTesting: '',
    devicesTestingCompleted: '',
    reviewApproved: '',
    deployRequested: '',
};

const commonCompletedModerationStateTexts: Record<DraftStatus, string> = {
    [DraftStatus.InDevelopment]: '',
    [DraftStatus.ReviewRequested]: t('ready'),
    [DraftStatus.ReviewApproved]: t('ready'),
    [DraftStatus.DeployRequested]: t('ready'),
};

const smartHomeCompletedModerationStateTexts: Record<DraftStatusSmartHome, string> = {
    [DraftStatusSmartHome.InDevelopment]: '',
    [DraftStatusSmartHome.ReviewRequested]: t('ready'),
    [DraftStatusSmartHome.MeetingApproval]: t('ready'),
    [DraftStatusSmartHome.WaitingForTesting]: t('ready'),
    [DraftStatusSmartHome.DevicesTesting]: t('ready'),
    [DraftStatusSmartHome.DevicesTestingCompleted]: t('ready'),
    [DraftStatusSmartHome.ReviewApproved]: t('ready'),
    [DraftStatusSmartHome.DeployRequested]: t('ready'),
};

export const completedModerationStateTexts = {
    [Channel.AliceSkill]: commonCompletedModerationStateTexts,
    [Channel.Thereminvox]: commonCompletedModerationStateTexts,
    [Channel.SmartHome]: smartHomeCompletedModerationStateTexts,
    [Channel.TvApp]: commonCompletedModerationStateTexts,
};
